import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
The main entry point for the Gift Guide Page.

Referenced by the page.gift-guide.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import GiftGuide from './apps/pages/gift-guide/GiftGuide';
import OVApp from './utils/OVContext';
import props from './apps/pages/gift-guide/props'; // Get component ID from Shopify page metafield

import { jsx as _jsx } from "react/jsx-runtime";
var pageElement = document.getElementById('gift-guide');
var componentId = pageElement.getAttribute('data-component-id');

if (componentId) {
  props.categories.idEMS = componentId;
}

ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
  children: /*#__PURE__*/_jsx(GiftGuide, _objectSpread({}, props))
}), document.getElementById('gift-guide'));